import axios from 'axios';
import queryString from 'qs';
import { PLATFORM } from '@/constants';
import { confirmPlatfrom } from './url-params';
import { getCookie } from './cookie';

let baseURL = '';

const TOKEN_NAME = 'study_token';
const APP_TOKEN_NAME = 'X-M-Auth-TOKEN';

export const createAxios = (baseURL) => {
  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
  };
  const isWeb = confirmPlatfrom() === PLATFORM.WEB.key;
  // const platformTokenName = isWeb ? WEB_TOKEN_NAME : APP_TOKEN_NAME;
  // web端暂时不传
  const platformTokenName = isWeb ? null : APP_TOKEN_NAME;
  const tokenName = isWeb ? TOKEN_NAME : APP_TOKEN_NAME;
  platformTokenName && (headers[platformTokenName] = getCookie(tokenName));
  return axios.create({
    baseURL,
    headers,
    transformRequest: [(data, headers) => {
      const ContentType = headers['Content-Type'];
      if (ContentType.indexOf('application/x-www-form-urlencoded') > -1) {
        return queryString.stringify(data);
      }
      if (ContentType.indexOf('application/json') > -1) {
        return JSON.stringify(data);
      }
      return data;
    }],
    transformResponse: [(_data) => {
      let data = {};
      try {
        data = JSON.parse(_data);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('networkError', e);
      }
      return data;
    }],
  });
};


let axiosInstance = createAxios(baseURL);

export const setBaseURL = (_baseURL) => {
  baseURL = _baseURL;
  axiosInstance = createAxios(baseURL);
};

export const request = (_config) => {
  const config = { ..._config };
  const isGet = config.method && config.method.toUpperCase() === 'GET';
  const hasGetParams = config.params && Object.keys(config.params).length;
  if (isGet && !hasGetParams) {
    config.params = config.data;
    config.data = null;
  }
  return axiosInstance(config).then((req) => {
    if (config.filterRequest) {
      return req.data.body;
    }
    return req.data;
  });
};

export const get = (url, params, options) => request({
  method: 'get',
  url,
  params,
  filterRequest: true,
  ...options,
});

export const post = (url, data) => request({
  method: 'post',
  url,
  data,
});
